import script from "./LoginLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__